var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fill-height" },
    [
      _vm.current_list.ID > 0
        ? _c(
            "v-container",
            { staticClass: "mt-0 pt-6", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "", align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("dialog-new-leads"),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "pt-0", attrs: { cols: "4" } },
                            [
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "pa-3 mb-2",
                                  attrs: { rounded: "", elevation: "1" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "append-icon": "mdi-magnify",
                                              label: "Search",
                                              "single-line": "",
                                              "hide-details": "",
                                              clearable: "",
                                              outlined: "",
                                              dense: "",
                                            },
                                            on: {
                                              "click:clear": function ($event) {
                                                return _vm.resetFilteredLeads()
                                              },
                                            },
                                            model: {
                                              value: _vm.lead_search,
                                              callback: function ($$v) {
                                                _vm.lead_search = $$v
                                              },
                                              expression: "lead_search",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-combobox", {
                                            attrs: {
                                              outlined: "",
                                              items: _vm.allTags,
                                              multiple: "",
                                              dense: "",
                                              clearable: "",
                                              placeholder: "Filter by Tag",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.selected_tags,
                                              callback: function ($$v) {
                                                _vm.selected_tags = $$v
                                              },
                                              expression: "selected_tags",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "elevation-1",
                                  staticStyle: { border: "none" },
                                  attrs: {
                                    loading: _vm.leads_loading,
                                    "loading-text": "Loading...",
                                  },
                                },
                                [
                                  _c(
                                    "v-tabs",
                                    {
                                      attrs: { grow: "" },
                                      model: {
                                        value: _vm.left_tabs,
                                        callback: function ($$v) {
                                          _vm.left_tabs = $$v
                                        },
                                        expression: "left_tabs",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab",
                                        { staticClass: "pt-4 pb-2" },
                                        [
                                          _vm._v("Contacts "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                                outlined: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.app.new_lead_dialog.show = true
                                                  _vm.app.new_lead_dialog.tab = 0
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(" mdi-plus "),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab",
                                        { staticClass: "pt-4 pb-2" },
                                        [
                                          Object.keys(_vm.app.tasks).length > 0
                                            ? _c(
                                                "v-badge",
                                                {
                                                  attrs: {
                                                    color: "accent",
                                                    content: Object.keys(
                                                      _vm.app.tasks
                                                    ).length,
                                                  },
                                                },
                                                [_vm._v("Tasks")]
                                              )
                                            : _c("span", [_vm._v("Tasks")]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab",
                                        { staticClass: "pt-4 pb-2" },
                                        [
                                          _c(
                                            "v-badge",
                                            {
                                              attrs: {
                                                color: "accent",
                                                content: "7",
                                              },
                                            },
                                            [_vm._v("Inbox")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.left_tabs,
                                        callback: function ($$v) {
                                          _vm.left_tabs = $$v
                                        },
                                        expression: "left_tabs",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-card-text",
                                            {
                                              directives: [
                                                {
                                                  name: "scroll",
                                                  rawName: "v-scroll.self",
                                                  value: _vm.onScroll,
                                                  expression: "onScroll",
                                                  modifiers: { self: true },
                                                },
                                              ],
                                              style: `height: calc((100vh - 233px) - ${_vm.app.bottom_height}px); overflow: auto;`,
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                { attrs: { dense: "" } },
                                                [
                                                  _vm._l(
                                                    _vm.filteredLeads,
                                                    function (contact, i) {
                                                      return [
                                                        !contact
                                                          ? _c("v-divider", {
                                                              key: `divider-${i}`,
                                                            })
                                                          : _c(
                                                              "v-list-item",
                                                              {
                                                                key: contact.ID,
                                                                class:
                                                                  _vm.contactClass(
                                                                    contact
                                                                  ),
                                                                attrs: {
                                                                  value:
                                                                    contact,
                                                                  dense: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.gotoContact(
                                                                        contact
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  {
                                                                    attrs: {
                                                                      dense: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        domProps:
                                                                          {
                                                                            innerHTML:
                                                                              _vm._s(
                                                                                _vm.format_lead_title(
                                                                                  contact
                                                                                )
                                                                              ),
                                                                          },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      {
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-container",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0 ma-0",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          _vm._l(
                                                                            _vm.scanContactForPhoneNumbers(
                                                                              contact
                                                                            ),
                                                                            function (
                                                                              phone_number
                                                                            ) {
                                                                              return _c(
                                                                                "v-row",
                                                                                {
                                                                                  key: phone_number,
                                                                                  attrs:
                                                                                    {
                                                                                      dense:
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-col",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          "line-height":
                                                                                            "32px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          cols: "10",
                                                                                          dense:
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.app.phoneNumberFormat(
                                                                                              phone_number
                                                                                            )
                                                                                          ) +
                                                                                          " " +
                                                                                          _vm._s(
                                                                                            _vm.app.phoneNumberStatus(
                                                                                              phone_number
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-col",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-right",
                                                                                      attrs:
                                                                                        {
                                                                                          cols: "2",
                                                                                          dense:
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          class:
                                                                                            _vm.app.phoneNumberStatusColor(
                                                                                              phone_number
                                                                                            ),
                                                                                          attrs:
                                                                                            {
                                                                                              fab: "",
                                                                                              "x-small":
                                                                                                "",
                                                                                              elevation:
                                                                                                "0",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                $event.preventDefault()
                                                                                                return _vm.dialContact(
                                                                                                  contact,
                                                                                                  phone_number
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _vm
                                                                                            .app
                                                                                            .contacts_unread_messages[
                                                                                            contact
                                                                                              .ID
                                                                                          ] &&
                                                                                          _vm
                                                                                            .app
                                                                                            .contacts_unread_messages[
                                                                                            contact
                                                                                              .ID
                                                                                          ]
                                                                                            .length >
                                                                                            0
                                                                                            ? _c(
                                                                                                "v-badge",
                                                                                                {
                                                                                                  attrs:
                                                                                                    {
                                                                                                      color:
                                                                                                        "accent",
                                                                                                      content:
                                                                                                        _vm
                                                                                                          .app
                                                                                                          .contacts_unread_messages[
                                                                                                          contact
                                                                                                            .ID
                                                                                                        ]
                                                                                                          .length,
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-icon",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "mdi-phone"
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            : _c(
                                                                                                "v-icon",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "mdi-phone"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-card-text",
                                            {
                                              style: `height: calc((100vh - 232px) - ${_vm.app.bottom_height}px); overflow: auto;`,
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                [
                                                  _c(
                                                    "v-list-item-group",
                                                    {
                                                      model: {
                                                        value: _vm.current_task,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.current_task = $$v
                                                        },
                                                        expression:
                                                          "current_task",
                                                      },
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.app.tasks,
                                                        function (item, i) {
                                                          return [
                                                            !item
                                                              ? _c(
                                                                  "v-divider",
                                                                  {
                                                                    key: `divider-${i}`,
                                                                  }
                                                                )
                                                              : _c(
                                                                  "v-list-item",
                                                                  {
                                                                    key: item.ID,
                                                                    attrs: {
                                                                      value:
                                                                        item,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.gotoContact(
                                                                            item.contact
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.format_lead_title(
                                                                                      item
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .current_list
                                                                                  .post_title
                                                                              ) +
                                                                                ": " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .contact
                                                                                    .post_title
                                                                                )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          {
                                                                            staticClass:
                                                                              "text--disabled",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.app.formatDateUTC(
                                                                                    item.post_date
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-action",
                                                                      [
                                                                        _c(
                                                                          "v-list-item-action-text",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                textContent:
                                                                                  _vm._s(
                                                                                    _vm.app.formatRelativeDateUTC(
                                                                                      item.post_date
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                        !item.completed
                                                                          ? _c(
                                                                              "v-icon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "grey lighten-1",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " mdi-star-outline "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "v-icon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "yellow darken-3",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " mdi-star "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-card-text",
                                            {
                                              style: `height: calc((100vh - 232px) - ${_vm.app.bottom_height}px); overflow: auto;`,
                                            },
                                            [_vm._v(" Inbox ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.current_list.ID > 0
                            ? _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass: "pa-3 mb-2",
                                      attrs: { rounded: "", elevation: "1" },
                                    },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.lists.lists,
                                          "item-text": "post_title",
                                          "item-value": "ID",
                                          "return-object": true,
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                          label: "Lists",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.lists.show_create_dialog = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(" mdi-plus "),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.lists.show_edit_dialog = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(" mdi-pencil "),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.post_title) +
                                                      " "
                                                  ),
                                                  _c("v-spacer"),
                                                  _vm.app.unread_messages[
                                                    item.ID
                                                  ]
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "accent",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Object.keys(
                                                                _vm.app
                                                                  .unread_messages[
                                                                  item.ID
                                                                ]
                                                              ).length
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                            {
                                              key: "selection",
                                              fn: function ({ item }) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.post_title) +
                                                      " "
                                                  ),
                                                  _vm.app.unread_messages[
                                                    item.ID
                                                  ]
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "accent",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              Object.keys(
                                                                _vm.app
                                                                  .unread_messages[
                                                                  item.ID
                                                                ]
                                                              ).length
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4159910753
                                        ),
                                        model: {
                                          value: _vm.current_list,
                                          callback: function ($$v) {
                                            _vm.current_list = $$v
                                          },
                                          expression: "current_list",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.current_lead &&
                                  _vm.current_lead.ID > 0 &&
                                  _vm.phone_number.length > 0
                                    ? _c("communications", {
                                        attrs: {
                                          phone_number: _vm.phone_number,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.current_list.ID > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0 px-3",
                                  attrs: { cols: "4" },
                                },
                                [
                                  _c("dialer", {
                                    model: {
                                      value: _vm.phone_number,
                                      callback: function ($$v) {
                                        _vm.phone_number = $$v
                                      },
                                      expression: "phone_number",
                                    },
                                  }),
                                  _c("v-hover", {
                                    attrs: { "close-delay": "1000" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ hover }) {
                                            return [
                                              _vm.current_lead &&
                                              _vm.current_lead.ID > 0
                                                ? _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass: "pa-3",
                                                      style: `height:calc(100vh - ${
                                                        278 +
                                                        _vm.app.bottom_height
                                                      }px);overflow:auto;`,
                                                      attrs: {
                                                        rounded: "",
                                                        elevation: "1",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-fab-transition",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: hover,
                                                                  expression:
                                                                    "hover",
                                                                },
                                                              ],
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "-7px",
                                                              },
                                                              attrs: {
                                                                fab: "",
                                                                absolute: "",
                                                                right: "",
                                                                "x-small": "",
                                                                color:
                                                                  "secondary",
                                                                elevation: "0",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.show_delete_lead = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-close"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.current_lead &&
                                                      _vm.current_lead.ID > 0 &&
                                                      !_vm.editLeadTitle
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pa-2 font-weight-bold",
                                                              on: {
                                                                click:
                                                                  _vm.clickedTitle,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "caption grey--text",
                                                                },
                                                                [_vm._v("Lead")]
                                                              ),
                                                              _vm.current_lead &&
                                                              _vm.current_lead
                                                                .ID > 0
                                                                ? _c("div", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.format_lead_title(
                                                                            _vm.current_lead
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.current_lead &&
                                                      _vm.current_lead.ID > 0 &&
                                                      _vm.editLeadTitle
                                                        ? _c("v-textarea", {
                                                            directives: [
                                                              {
                                                                name: "click-outside",
                                                                rawName:
                                                                  "v-click-outside",
                                                                value:
                                                                  _vm.clickOutside,
                                                                expression:
                                                                  "clickOutside",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "pa-2 body-2",
                                                            attrs: {
                                                              label: "Lead",
                                                              "auto-grow": "",
                                                              rows: "1",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.current_lead
                                                                  .post_title,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.current_lead,
                                                                    "post_title",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "current_lead.post_title",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm.current_lead &&
                                                      _vm.current_lead.ID > 0 &&
                                                      !_vm.editLeadNotes
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pa-2 body-2",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.clickedNotes.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "caption grey--text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Notes"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._l(
                                                                _vm.current_lead.post_content.split(
                                                                  /\r?\n/
                                                                ),
                                                                function (
                                                                  line,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "v-row",
                                                                    {
                                                                      key: `${index}:${line}`,
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm.contains_task_date(
                                                                        line,
                                                                        index
                                                                      )
                                                                        ? [
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    cols: "1",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-checkbox",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "accent",
                                                                                        dense:
                                                                                          "",
                                                                                        "hide-details":
                                                                                          "",
                                                                                      },
                                                                                    on: {
                                                                                      change:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.updateTaskStatus(
                                                                                            $event,
                                                                                            index
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .contact_tasks[
                                                                                            `'${_vm.current_lead.ID}'`
                                                                                          ][
                                                                                            index
                                                                                          ]
                                                                                            .complete,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .contact_tasks[
                                                                                                `'${_vm.current_lead.ID}'`
                                                                                              ][
                                                                                                index
                                                                                              ],
                                                                                              "complete",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "contact_tasks[`'${current_lead.ID}'`][index].complete",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "pt-3",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "11",
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        _vm.format_lead_content(
                                                                                          line
                                                                                        )
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        : !_vm.containsFieldName(
                                                                            line
                                                                          )
                                                                        ? [
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "line-height":
                                                                                      "1.8",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    cols: "12",
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        _vm.format_lead_content(
                                                                                          line
                                                                                        )
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        : [
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "font-weight-bold",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "3",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    line.substring(
                                                                                      0,
                                                                                      line.indexOf(
                                                                                        ":"
                                                                                      )
                                                                                    )
                                                                                  ) +
                                                                                    ":"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    cols: "9",
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        _vm.format_lead_content(
                                                                                          line.substring(
                                                                                            line.indexOf(
                                                                                              ":"
                                                                                            ) +
                                                                                              1
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                    ],
                                                                    2
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                      _vm.current_lead.ID > 0 &&
                                                      _vm.editLeadNotes
                                                        ? _c("v-textarea", {
                                                            directives: [
                                                              {
                                                                name: "click-outside",
                                                                rawName:
                                                                  "v-click-outside",
                                                                value:
                                                                  _vm.clickOutside,
                                                                expression:
                                                                  "clickOutside",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "pa-2 body-2",
                                                            staticStyle: {
                                                              "line-height":
                                                                "1.5",
                                                            },
                                                            attrs: {
                                                              label: "Notes",
                                                              "auto-grow": "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.current_lead
                                                                  .post_content,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.current_lead,
                                                                    "post_content",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "current_lead.post_content",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1326463558
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-speed-dial",
                {
                  attrs: {
                    direction: "top",
                    absolute: "",
                    bottom: "",
                    right: "",
                    "open-on-hover": "",
                    transition: "slide-y-reverse-transition",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function () {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "blue darken-2",
                                  dark: "",
                                  fab: "",
                                },
                                model: {
                                  value: _vm.fab,
                                  callback: function ($$v) {
                                    _vm.fab = $$v
                                  },
                                  expression: "fab",
                                },
                              },
                              [
                                _vm.fab
                                  ? _c("v-icon", [_vm._v(" mdi-close ")])
                                  : _c("v-icon", [
                                      _vm._v(" mdi-account-circle "),
                                    ]),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    966269411
                  ),
                  model: {
                    value: _vm.fab,
                    callback: function ($$v) {
                      _vm.fab = $$v
                    },
                    expression: "fab",
                  },
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", value: `true` },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          fab: "",
                                          dark: "",
                                          small: "",
                                          color: "green",
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-pencil")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2102663173
                      ),
                    },
                    [_c("span", [_vm._v("Left tooltip")])]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { fab: "", dark: "", small: "", color: "indigo" },
                    },
                    [_c("v-icon", [_vm._v("mdi-plus")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    { attrs: { fab: "", dark: "", small: "", color: "red" } },
                    [_c("v-icon", [_vm._v("mdi-delete")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.current_list.ID == null && _vm.user.code != "login_required"
        ? _c(
            "v-container",
            { staticClass: "fill-height", attrs: { fluid: "" } },
            [
              _vm.lists.loading
                ? _c(
                    "v-container",
                    { staticClass: "text-center", attrs: { fluid: "" } },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: 70,
                          width: 7,
                        },
                      }),
                      _c("div", { staticClass: "text-overline" }, [
                        _vm._v("Loading"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.show_delete_lead
        ? _c("dialog-delete-lead", {
            attrs: { req: _vm.app.req, lead: _vm.current_lead },
            on: { close: _vm.closeDeleteDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }